import {
    Component, Input, Output, EventEmitter, OnInit,
} from '@angular/core';
import * as _ from 'lodash';

import { BaseModalComponent } from '../../modal/_base-modal.component';
import { PreferencesService } from '../../preferences/preferences.service';


@Component({
  moduleId: module.id,
  selector: 'billing-info-modal',
  templateUrl: 'billing-info-modal.component.html',
  styleUrls: ['billing-info-modal.component.scss'],
})
export class BillingInfoModalComponent extends BaseModalComponent implements OnInit {

  timezone: string;
  formatDateStr = 'MMMM do, YYYY';

  @Input() cardInfo: any;
  @Input() billingDate: string;

  @Output() updateCardClicked = new EventEmitter();
  @Output() shareInvoiceClicked = new EventEmitter();

  constructor(
    private preferencesService: PreferencesService
  ) {
    super();
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

   ngOnInit() {
     this.preferencesService.getPreferences()
       .subscribe((preferences: any) => {
         this.timezone = preferences.timezone;
       });
   }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

   get isVisa(): boolean {
     return _.get(this.cardInfo, 'card_brand') === 'Visa';
   }

   get cardLastNumbers(): string {
     return _.get(this.cardInfo, 'card_last_four');
   }

   get cardHolderName(): string {
     return _.get(this.cardInfo, 'card_holder_name');
   }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onUpdateCardClick() {
    this.updateCardClicked.emit();
  }

  onShareInvoiceClick(event: MouseEvent) {
    event.preventDefault();
    this.shareInvoiceClicked.emit();
  }
}
